<template>
    <div
        class="flex flex-col items-center mt-10">
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-width="130px"
            label-suffix=":"
            class="brand-list-form"
            label-position="right">
            <el-form-item :label="$t('Staff.Modify.old')" prop="oldPhone">
                <el-input
                    maxlength="11"
                    style="width: 400px;"
                    type="text"
                    v-model="form.oldPhone" />
            </el-form-item>
            <el-form-item :label="$t('Staff.Modify.code')" prop="oldPhoneCode">
                <el-input
                    :placeholder="$t('Fill.code')"
                    style="width: 308px;"
                    type="text"
                    v-model="form.oldPhoneCode" />
                <el-button style="width: 92px;" type="primary" @click="handleCode('old')">
                    {{ list.old.msg }}
                </el-button>
            </el-form-item>
            <el-form-item :label="$t('Staff.Modify.password')" prop="password">
                <el-input
                    :placeholder="$t('Common.fill_password')"
                    style="width: 400px;"
                    type="password"
                    v-model="form.password" />
            </el-form-item>
            <el-form-item :label="$t('Staff.Modify.new')" prop="newPhone">
                <el-input
                    maxlength="11"
                    :placeholder="$t('Staff.Modify.fill_new')"
                    style="width: 400px;"
                    type="text"
                    v-model="form.newPhone" />
            </el-form-item>
            <el-form-item :label="$t('Staff.Modify.code')" prop="newPhoneCode">
                <el-input
                    :placeholder="$t('Fill.code')"
                    style="width: 308px;"
                    type="text"
                    v-model="form.newPhoneCode" />
                <el-button style="width: 92px;" type="primary" @click="handleCode('new')">
                    {{ list.new.msg }}
                </el-button>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="submit()">{{ $t('Message.confirm') }}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
// import FileUpload from '@/components/base/FileUpload.vue';
import {mapState} from 'vuex';

export default {
    components: {
    },
    data() {
        return {
            form: {
                oldPhone: '',
                newPhone: '',
                password: '',
                oldPhoneCode: '',
                newPhoneCode: '',
            },
            rules: {
                oldPhone: { required: true },
                newPhone: { required: true, message: this.$t('Staff.Modify.fill_new') },
                password: { required: true, message: this.$t('Common.fill_password') },
                oldPhoneCode: { required: true, message: this.$t('Fill.code') },
                newPhoneCode: { required: true, message: this.$t('Fill.code') },
            },
            list: {
                old: {
                    timer: null,
                    second: 60,
                    msg: this.$t('Staff.Modify.handle_code'),
                },
                new: {
                    timer: null,
                    second: 60,
                    msg: this.$t('Staff.Modify.handle_code'),
                },
            },
        };
    },
    computed: {
        ...mapState([
            'my',
        ]),
    },
    created() {
        this.form.oldPhone = this.my.phone;
    },
    methods: {
        handleCode(type) {
            if (this.list[type].timer) return false;
            const url = type === 'old' ? 'sms/old-phone' : 'sms/new-phone';
            const form = {
                phone: type === 'old' ? this.form.oldPhone : this.form.newPhone,
            };
            const myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(17[0-3]{1})|(15[0-3]{1})|(15[5-9]{1})|(18[0-9]{1}))+\d{8})$/;
            if (form.phone.length !== 11 && !myreg.test(form.phone))
                return $ele.$message.warning(this.$t('Staff.Modify.correct'));

            API.post(url, form).then(res => {
                $ele.$message.success(this.$t('Staff.Modify.code_success'));
                this.list[type].timer = setInterval(() => {
                    if (this.list[type].second) {
                        this.list[type].second--;
                        this.list[type].msg= `${this.list[type].second}${this.$t('Staff.Modify.refresh')}`;
                        return;
                    }
                    clearInterval(this.list[type].timer);
                    // timer 重置
                    this.list[type].timer = null;
                    this.list[type].second = 60;
                    this.list[type].msg= this.$t('Staff.Modify.again');
                }, 1000);
            });
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.postData();
            });
        },
        postData() {
            API.post('my/transfer-account', this.form).then(() => {
                $ele.$message.success(this.$t('Staff.Modify.success'));
                setTimeout(() => {
                    this.logout();
                }, 1000);
            });
        },
        logout() {
            const loadingInstance = $ele.$loading();
            API.post('auth/logout').then((res) => {
                loadingInstance.close();
                sessionStorage.clear();
                window.location.reload();
            });
        },
    },
}
</script>

<style lang="scss">
</style>
